import { Injectable } from '@angular/core';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  AsyncSubject,
  forkJoin,
  of,
} from 'rxjs';
import { map, switchMap, first, mergeAll } from 'rxjs/operators';
import {
  EventGetModel,
  EventAddModel,
  TicketPrice,
  BlogPostGetModel,
  BlogPostAddModel,
} from '../interfaces/interfaces';
import { PassDataService } from '../services/pass-data.service';
import * as moment from 'moment';
import { BlogPostDataService } from '../data/blog-post.service';

@Injectable({
  providedIn: 'root',
})
export class BlogPostLogicService {
  deleteId: string = '';
  deleteImagesName: string[] = [];

  constructor(
    private blogPostDataService: BlogPostDataService,
    private passDataService: PassDataService
  ) { }

  getAllBlogPostsLogic(): Observable<BlogPostGetModel[]> {
    return this.blogPostDataService.getAllBlogPostsData().pipe(
      switchMap((d) => {
        let blogPosts = [];
        for (let i = 0; i < d.length; i++) {
          let blogPost = d[i] as BlogPostGetModel;

          const postedDateToShow = moment(blogPost.postedDate).format("DD-MM-YYYY, hh:mm A");

          let eventModel = new BlogPostGetModel(
            blogPost._id,
            blogPost.title,
            blogPost.description,
            blogPost.postedDate,
            blogPost.postedBy,
            blogPost.post,
            blogPost.imageUrls,
            postedDateToShow
          );

          blogPosts.push(eventModel);
        }
        return [blogPosts];
      })
    );
  }

  async addBlogPostLogic(
    title: string,
    description: string,
    postedDate: string,
    postedBy: string,
    post: string,
    files: File[]
  ) {
    const imageLinks = await this.blogPostDataService.uploadBlogPostImageData(files);
    return this.blogPostDataService.addBlogPostData(
      new BlogPostAddModel(
        title,
        description,
        postedDate,
        postedBy,
        post,
        imageLinks
      )
    )
  }

  async updateBlogPostLogic(
    id: string,
    title: string,
    description: string,
    postedDate: string,
    postedBy: string,
    post: string,
    files: any,
    imageUrls: string[]
  ) {

    let imageLinks: any[] = [];

    if (files.length !== 0) {
      imageLinks = await this.blogPostDataService.uploadBlogPostImageData(files);
      imageUrls.push(...imageLinks)
      return this.blogPostDataService.updateBlogPostData(
        new BlogPostGetModel(
          id,
          title,
          description,
          postedDate,
          postedBy,
          post,
          imageUrls
        )
      )
    } else {
      return this.blogPostDataService.updateBlogPostData(
        new BlogPostGetModel(
          id,
          title,
          description,
          postedDate,
          postedBy,
          post,
          imageUrls
        )
      )
    }
  }

  async deleteBlogPostLogic(data: any) {
    const resp = await this.blogPostDataService.deleteBlogPostData(data?._id, data?.imageUrls);
    //console.log(resp)
    return resp
  }

  async deleteBlogPostImageLogic(blogPostId: string, link: string, links: string[]) {
    const data = await this.blogPostDataService.deleteBlogPostImageAndUpdate(blogPostId, link, links);
    if (data == "success") {
      const filter = links.filter(f => f !== link);
      await this.blogPostDataService.updateBlogPostImageData(blogPostId, filter)
      return { message: "success", links: filter }
    } else {
      return "error"
    }
  }
}
